import styled from 'styled-components';
import Eyebrow from '@klv/atoms/eyebrow';
import Typography from '@klv/atoms/typography';
import Buttons from '@klv/molecules/buttons';
import { setTextHoverColor } from '../utils/functions';
import type { TRelatedContentCardHoverColor, ITransientProps } from '../types';

export const BodyCopy = styled(Typography)`
  z-index: 1;
`;

export const HoverImageContainer = styled.div`
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: ${({ theme }) => `opacity ${theme.transition.string}, visibility ${theme.transition.string}`};
  visibility: hidden;
  &::after {
    background: linear-gradient(180deg, rgba(35,36,38,0.8) 0%, rgba(35,36,38,0.3) 30%, rgba(35,36,38,0) 100%);
    bottom: 0;
    content: '';
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
  }
`;

export const RelatedContentLink = styled.a`
  text-decoration: none;
  z-index: 1;

  &::after {
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const StyledButtons = styled(Buttons)`
  display: inline-block;
  margin-top: 2.4rem;
  z-index: 2;
`;

export const StyledEyebrow = styled(Eyebrow)`
  margin-bottom: auto;
  z-index: 1;
`;

export const StyledHeadline = styled(Typography)`
  margin-bottom: 1.6rem;
  margin-top: 1.6rem;
  z-index: 1;
`;

export const StyledRelatedContentCard = styled.article<ITransientProps>`
  align-items: flex-start;
  border: ${({ theme, $variant }) => `1px solid ${($variant === 'dark') ? theme.relatedContentCard.dark.border : theme.relatedContentCard.light.border}`};
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  max-width: 41.6rem;
  overflow: hidden;
  padding: 2.4rem;
  position: relative;
  scroll-snap-align: start;
  transition: ${({ theme }) => `background ${theme.transition.string}, color ${theme.transition.string}`};
  white-space: normal;
  width: calc((((100% - (24px * 7)) / 8) * 7) + (24px * 6));

  ${({ theme }) => theme.screenSize.s768.mediaQuery} {
    padding: 3.2rem;
    width: calc((((100% - (24px * 11)) / 12) * 6) + (24px * 6));
  }

  ${({ theme }) => theme.screenSize.s1024.mediaQuery} {
    width: calc((((100% - (24px * 11)) / 12) * 5) + (24px * 4));
  }

  ${({ theme }) => theme.screenSize.s1366.mediaQuery} {
    width: calc((((100% - (24px * 11)) / 12) * 4) + (24px * 3));
  }

  ${StyledEyebrow} {
    color: ${({ theme, $variant }) => (($variant === 'dark') ? theme.relatedContentCard.dark.eyebrow : theme.relatedContentCard.light.eyebrow)};
  }

  ${StyledHeadline},
  ${BodyCopy} {
    color: ${({ theme, $variant }) => theme.relatedContentCard[$variant].text};
  }

  &:hover,
  &:focus,
  &:focus-within {
    background-color: ${({
    $hasImage, $solidCardHoverColor, theme, $variant,
  }) => (
    !$hasImage ? theme.relatedContentCard[$variant].solidCardHoverColor[$solidCardHoverColor as keyof TRelatedContentCardHoverColor] : ''
  )};
    outline: none;

    ${BodyCopy},
    ${StyledEyebrow},
    ${StyledHeadline} {
      color: ${({
    $hasImage, $solidCardHoverColor, theme, $variant,
  }) => setTextHoverColor({
    $hasImage, $solidCardHoverColor, theme, $variant,
  })};
    }

    ${HoverImageContainer} {
      opacity: 1;
      transition: ${({ theme }) => `opacity ${theme.transition.string}, visibility ${theme.transition.string}`};
      visibility: visible;
    }
  } 
`;
